<script>
/**
 * Descripción: Formulario reutilizable
 *
 * @displayName BaseForm
 */

import BaseLocalHelper from '@/helpers/BaseLocalHelper';

import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'BaseForm',

  props: {
    /**
     * Label del Primer botón
     * Default: Guardar
     */
    labelBtn: {
      type: String,
      default: BaseLocalHelper.$_LabelBtnSend
    },

    beforeClick: {
      type: Function,
      default: undefined
    },

    enterSubmit: {
      type: Boolean,
      default: true
    },

    /**
     * Color del Primer botón
     * Default: primary
     */
    color: {
      default: 'primary'
    },

    /**
     * Icon del Primer botón
     * Default: mdi-content-save
     */
    icon: {
      default: 'mdi-content-save'
    },

    /**
     * Unico botón que abarca tamaño del form
     * Default: false
     */
    login: {
      type: Boolean,
      default: false
    },

    /**
     * Función a ejecutar en el form con el primer btn
     * Requerida
     */
    method: {
      type: Function,
      required: true
    },

    /**
     * Función a ejecutar en el form con el botón Cancelar
     * no es Requerido
     */
    cancel: {
      type: Function,
      default: undefined
    }
  },

  data() {
    return {
      valid: true,
      lblCancel: BaseLocalHelper.$_LabelBtnGoOut,
      showCancel: false,
      /**
       * Identificador del input
       */
      refForm: 'BaseForm_'
    };
  },

  created() {
    /**
     * Valida si es necesario el botón de Cancelar
     */
    if (this.$props.cancel != undefined) {
      this.showCancel = true;
    }

    const randomID = uuidv4();

    /**
     * Config Inicial ID
     */
    this.refForm = this.refForm + randomID;
  },

  methods: {
    /**
     * Valida el form y ejecuta la función 'method'
     */
    $_submit() {
      if (this.beforeClick != undefined) {
        this.beforeClick();
      }

      if (this.$refs[this.refForm].validate()) {
        this.method();
        this.$nextTick(() => {
          if (this.$refs[this.refForm] != undefined) {
            this.$refs[this.refForm].resetValidation();
          }
        });
      }
    },

    /**
     * limpia el form y ejecuta la función 'Cancelar'
     */
    $_Cancel() {
      if (this.showCancel === true) {
        if (this.$refs[this.refForm] != undefined) {
          this.cancel();
          this.$refs[this.refForm].reset();
        }
      }
    },

    /**
     * limpia el form y ejecuta la función 'Cancelar'
     */
    $_Clean() {
      this.$refs[this.refForm].reset();
      this.$refs[this.refForm].resetValidation();
    }
  }
};
</script>

<template>
  <div>
    <v-form
      :ref="refForm"
      v-model="valid"
      lazy-validation
      @keyup.enter.native="$_submit"
      v-if="enterSubmit === true"
    >
      <v-container>
        <!-- @slot Agregar Contenido del form -->
        <slot name="body"></slot>
      </v-container>
      <!-- @slot Agregar Contenido sin Container del form -->
      <slot name="containerBody"></slot>
    </v-form>

    <v-form
      :ref="refForm"
      v-model="valid"
      lazy-validation
      v-if="enterSubmit === false"
    >
      <v-container>
        <!-- @slot Agregar Contenido del form -->
        <slot name="body"></slot>
      </v-container>
      <!-- @slot Agregar Contenido sin Container del form -->
      <slot name="containerBody"></slot>
    </v-form>

    <!-- @slot Agregar Contenido después del form -->
    <slot name="afterForm"></slot>
    <br />
    <v-layout align-center justify-end v-if="login">
      <v-btn block :color="color" dark @click="$_submit">{{ labelBtn }}</v-btn>
      <!-- @slot Agregar botones después del Btn principal -->
      <slot name="btns"></slot>
    </v-layout>
    <v-layout align-end justify-end v-if="!login">
      <!-- @slot Agregar botones después del Btn principal -->
      <slot name="Beforebtns"></slot>

      <v-btn class="ma-2" :color="color" dark @click="$_submit">
        <v-icon left>{{ icon }}</v-icon>
        {{ labelBtn }}
      </v-btn>

      <v-btn class="ma-2" @click="$_Cancel" v-if="showCancel">
        <v-icon left>mdi-close-circle</v-icon>
        {{ lblCancel }}
      </v-btn>

      <!-- @slot Agregar botones después del Btn principal -->
      <slot name="Afterbtns"></slot>
    </v-layout>
  </div>
</template>
